import React, { useState } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { auth } from '../services/auth'; 

export default function PrivateRoute() {
	const [user, setUser] = useState(auth().getUser());
	return (
		user ? <Outlet /> : <Navigate to="/login" />
	)
}
